var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content"
        },
        [
          _c(
            "search-item",
            {
              attrs: { "config-module": "231402", reset: true, no: "1" },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery,
                advSearchItemResetCallBack: _vm.toAdvancedQuery
              },
              scopedSlots: _vm._u([
                {
                  key: "customCompany",
                  fn: function(ref) {
                    var item = ref.item
                    var getValueFromChild = ref.getValueFromChild
                    return _c("cargo-advance-select", {
                      attrs: {
                        "select-type": _vm.TYPE_NAMES.basic_data_Company,
                        "clear-not-match": true,
                        filterable: "",
                        "callback-params": {
                          refCode: item.itemName,
                          fieldType: item.fieldType
                        },
                        "default-multiple-value":
                          item.itemValue instanceof Array ? item.itemValue : [],
                        multiple: true,
                        "tag-value":
                          item.tagValue !== ""
                            ? item.tagValue
                            : item.subType.tagValue,
                        "options-width": "300px",
                        headers: item.headers || [],
                        fields: item.fields || [],
                        "tag-name": item.tagName,
                        placeholder: " ",
                        "static-options": _vm.overCreditAccounts
                      },
                      on: {
                        parentCallBack: function(data) {
                          return getValueFromChild(data)
                        }
                      }
                    })
                  }
                }
              ])
            },
            [
              _c("template", { slot: "operations" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "2" },
                        on: {
                          click: function($event) {
                            return _vm.toCancelSpecialApproval(null)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_CancelSpecialApproval"))
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "23140200",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  no: "3"
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "23140200",
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "page-sizes": [10, 20, 30, 50, 100, 200, 500],
                  no: "4"
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("credit-info-dialog", {
        ref: "creditInfo",
        attrs: {
          visible: _vm.creditInfoVisible,
          "dialog-row-data": _vm.creditInfoList,
          no: "5"
        },
        on: { onClose: _vm.creditInfoClose }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }